import React, { useState, useEffect } from "react";
// import "./Header.css";
import Loader from "react-loader-spinner";
import createBestOf from "../../requests/create";
import updateBestOf from "../../requests/update";
import publishBestOf from "../../requests/publish";
import { formatArrayPost, formatBestOfBostApi } from "../../utils/format";
import { AiOutlineEdit, AiOutlineCheckCircle } from "react-icons/ai";
import * as moment from 'moment'
import { useBestOf } from "../../context/BestOf";
import { useMenuBestOf } from "../../context/MenuBestOf";
import SwitchButton from "../../utils/SwitchButton";
import Button from "@material-ui/core/Button";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';

import { makeStyles, useTheme } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  button: {
    fontSize: "1em",
    borderRadius: "5px",
    margin: "10px 0px",
    cursor: "pointer",
    width: "200px"
  },
  buttonHeaderGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly"
  },
  fetchHeaderGroup: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  titleHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "10px",
    marginBottom: "10px"
  },
  modifyTitleBestOf: {
    color: theme.palette.primary.dark,
    marginLeft: 20,
    width: 35,
    height: 35
  }
}));

const Header = () => {
  const classes = useStyles();
  const theme = useTheme();
  const { state: stateB, dispatch} = useBestOf();
  const { dispatch: dispatchMenu, state: stateMenu} = useMenuBestOf();
  const [firstClickBackMenu, setFirstClickBackMenu] = useState(0);
  const [messageInfo, setMessageInfo] = useState<any | undefined>({});
  const [isLoading, setIsLoadingState] = useState(0);

  useEffect(() => {
    if (!stateMenu.pickedBestOf) {
      dispatch({type: "SET_TITLE_BEST_OF", payload: {
        title: `Best Of du ${moment.utc(stateB.allDayBestOf[0]).format("DD/MM/YY")} au ${moment.utc(stateB.allDayBestOf[stateB.allDayBestOf.length - 1]).format("DD/MM/YY")}`
      }})
    } else {
      dispatch({type: "SET_TITLE_BEST_OF", payload: {title: stateMenu.pickedBestOf.title}})
    }
  }, [stateB.allDayBestOf, dispatch, stateMenu.pickedBestOf]);

  useEffect(() => {
    if (stateB.title.generate) {
      let makeTitle = "Best Of : ";
      console.log(stateB.postCover.length)
      for (let i = 0; i < 2; i++) {
        if (stateB.postCover.length - 1 >= i) {
          if (i !== 0)
            makeTitle += ";"
          makeTitle += stateB.postCover[i].title;
        }
      }
      dispatch({type: "SET_TITLE_BEST_OF", payload: {title: makeTitle}})
    }
  }, [stateB.postCover, stateB.title.generate, dispatch])

  const setIsLoading = (isLoading: any) => {
    setMessageInfo({});
    setIsLoadingState(isLoading);
  };

  const saveInDb = (isPublish: any) => {
    setIsLoading(1);

    if (!stateMenu.pickedBestOf) {
      // Si c'est un nouveau best of il est alors créé
      createBestOf(stateB.title.text, stateB.allDayBestOf, formatBestOfBostApi(stateB.postByDay), formatArrayPost(stateB.postCover), stateMenu.typeBestOf)
        .then((data) => {
          console.log(data);  
          if (!data.message) {
            dispatchMenu({type: "SET_PICKED_BEST_OF", payload: {pickedBestOf: data}})
            dispatchMenu({type: "SET_IS_NEW_BEST_OF", payload: {isNewBestOf: false}})
            setIsLoading(0);
            setMessageInfo({status: 200, message: "Le best of à été créer !"});
            dispatch({type: "SET_BEST_OF_SAVE", payload: {isSave: true}});
          } else {
            console.log(data.message)
            setIsLoading(0);
            setMessageInfo({status: 400, message: data.message});
          }
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(0);
          setMessageInfo({status: 400, message: "Une erreur est survenu lors de la crétion du best of !"});
        });
    } else {
      // Si le best of à déjà été créé il est alors mis à jour
      // Tant qu'un best of n'a pas été publié il peut être sauvegarder
      // Si le best of est publier alors il est mis à jour et republier (Email aux membres leur indiquant que le best of à été mis à jour)
      console.log("This: ", stateMenu.pickedBestOf);
      updateBestOf(
        stateMenu.pickedBestOf,
        stateB.title.text,
        stateB.allDayBestOf,
        formatBestOfBostApi(stateB.postByDay),
        formatArrayPost(stateB.postCover),
        isPublish
      )
        .then((data: any) => {
          console.log(data);
          if (data.Attributes) {
            dispatchMenu({type: "SET_PICKED_BEST_OF", payload: {pickedBestOf: { ...stateMenu.pickedBestOf, ...data.Attributes }}})
            dispatchMenu({type: "SET_IS_NEW_BEST_OF", payload: {isNewBestOf: false}})
            setIsLoading(0);
            setMessageInfo({status: 200, message: "Le best of à été mis à jour !"});
            dispatch({type: "SET_BEST_OF_SAVE", payload: {isSave: true}});
          } else {
            setIsLoading(0);
            setMessageInfo({status: 400, message: data.message});
          }
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(0);
          setMessageInfo({status: 400, message: "Une erreur est survenu la mis à jour du best of !"});
        });
    }
  };

  const publish = () => {
    setIsLoading(1);
    // Publication du best of un email est envoyé aux membres leur indiquant qu'un nouveau best of à été publier
    publishBestOf(stateMenu.pickedBestOf.bestOfId)
      .then((data) => {
        if (!data.message && data.Attributes) {
          dispatchMenu({type: "SET_PICKED_BEST_OF", payload: {pickedBestOf: { ...stateMenu.pickedBestOf, ...data.Attributes }}})
          setIsLoading(0);
          setMessageInfo({status: 200, message: "Le best of à été publié !"});
        } else {
          setIsLoading(0);
          setMessageInfo({status: 400, message: data.message});
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(0);
        setMessageInfo({status: 400, message: "Une erreur est survenu pendant la publication !"});
      });
  };

  const goBackMenu = () => {
    // Retour au menu, sécurité il faut appuyer 2 fois : à la première indiquation disant de sauvegarder sinon le travaille sera perdu, la deuxième retour au menu
    if (firstClickBackMenu > 0) {
      dispatchMenu({type: "SET_PICKED_BEST_OF", payload: {pickedBestOf: null}});
      dispatchMenu({type: "SET_IS_NEW_BEST_OF", payload: {isNewBestOf: false}});
    } else {
      setFirstClickBackMenu(firstClickBackMenu + 1);
      setMessageInfo({status: 400, message: "Attention ! Pensez à sauvegarder votre travail, pour aller au menu appuyer une nouvelle fois"});
    }
  };

  const editTitle = (e: any) => {
    dispatch({type: "SET_TITLE_BEST_OF", payload: {title: e.target.value}});
  };

  return (
    <div style={{width: '80%'}}>
      <div className={classes.titleHeader}>
        {stateB.title.modify === 1 ? (
          <TextareaAutosize
            className="form__input"
            value={stateB.title.text}
            onChange={editTitle}
            placeholder="Search by posts"
            aria-label="minimum height" rowsMin={2}
          />
        ) : (
          <h1 className="title-best-of">{stateB.title.text}</h1>
        )}
        {stateB.title.modify === 1 ? (
          <AiOutlineCheckCircle
            onClick={() =>  dispatch({type: "MODIFY_TITLE_BEST_OF", payload: {modify: 0}})}
            className={classes.modifyTitleBestOf}
          />
        ) : (
          <AiOutlineEdit
            onClick={() => dispatch({type: "MODIFY_TITLE_BEST_OF", payload: {modify: 1}})}
            className={classes.modifyTitleBestOf}
          />
        )}
        <br/>
      </div>
      <div className={classes.buttonHeaderGroup}>
        <SwitchButton value={false}/>
        <Button variant="outlined" className={classes.button} onClick={() => goBackMenu()}>
          Menu
        </Button>
        <Button variant="outlined"
          className={classes.button}
          onClick={() => {saveInDb(stateMenu.pickedBestOf ? stateMenu.pickedBestOf.publish : false);}}
          disabled={stateMenu.pickedBestOf && stateMenu.pickedBestOf.publish && stateB.postCover.length !== 4}
        >
          {!stateMenu.pickedBestOf || !stateMenu.pickedBestOf.publish
            ? "Sauvegarder"
            : "Mettre à jour et publier"}
        </Button>
        {stateMenu.pickedBestOf && !stateMenu.pickedBestOf.publish && (
          <Button variant="outlined" disabled={stateB.postCover.length !== 4 || stateB.isSave === false} className={classes.button} onClick={() => publish()}>
            Publier
          </Button>
        )}
      </div>
      <div className={classes.fetchHeaderGroup}>
        {isLoading > 0 && (
          <Loader type="Oval" height={40} width={40} color={theme.palette.primary.dark}/>
        )}
        <p style={(messageInfo.status === 200) ? {color: "green"} : {color: "red"}}>{messageInfo.message}</p>
      </div>
    </div>
  );
};

export default Header;
